import React from "react";
import ScrollReveal from "@/components/ScrollReveal";
import SubscriptionPlans from "@/components/subscription/SubscriptionPlans";
import type { SubscriptionTier } from "@/config/subscriptionTiers";

interface Props {
  currentTier?: SubscriptionTier | null;
  subscribed?: boolean;
}

const PricingBand: React.FC<Props> = ({ currentTier, subscribed }) => {
  return (
    <section id="pricing" className="py-24 md:py-32 px-6 relative overflow-hidden">
      <div className="absolute inset-0 z-[-1] bg-cosmic-radial opacity-30" />

      <div className="container mx-auto max-w-6xl">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <ScrollReveal>
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wide text-cosmic-200 border border-cosmic-400/30 bg-cosmic-900/50 backdrop-blur-sm mb-4">
              Choose your rhythm
            </span>
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-6 text-gradient">
              Start today. Cancel anytime.
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={200}>
            <p className="text-white/70 text-lg leading-relaxed">
              No free trial, just a low monthly option if you want to dip your toes in. Save
              more with quarterly or annual.
            </p>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={120}>
          <SubscriptionPlans currentTier={currentTier} subscribed={subscribed} />
        </ScrollReveal>
      </div>
    </section>
  );
};

export default PricingBand;
